import { AppLanguage, RouteNameEnum } from '../enums';

import { getRouteNamesByUrl } from './getRouteNamesByUrl.utils';

export function getRouteNameByUrl(url: string, language?: AppLanguage): RouteNameEnum | undefined {
  return getRouteNamesByUrl(url, language)?.[0];
}
